var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "firmware-manage" }, [
    _c(
      "div",
      [
        _c("div", { staticClass: "title" }, [_vm._v("固件管理")]),
        _c(
          "el-form",
          { ref: "form", staticClass: "search-form", attrs: { inline: true } },
          [
            _c(
              "el-col",
              { attrs: { span: 24 } },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "固件名称" } },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "请输入固件名称", clearable: "" },
                      model: {
                        value: _vm.formSearch.name,
                        callback: function ($$v) {
                          _vm.$set(_vm.formSearch, "name", $$v)
                        },
                        expression: "formSearch.name",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "固件Key" } },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "请输入固件Key", clearable: "" },
                      model: {
                        value: _vm.formSearch.componentInfoId,
                        callback: function ($$v) {
                          _vm.$set(_vm.formSearch, "componentInfoId", $$v)
                        },
                        expression: "formSearch.componentInfoId",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "固件类型" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { clearable: "" },
                        model: {
                          value: _vm.formSearch.componentType,
                          callback: function ($$v) {
                            _vm.$set(_vm.formSearch, "componentType", $$v)
                          },
                          expression: "formSearch.componentType",
                        },
                      },
                      _vm._l(_vm.firmwareTypeOptions, function (item) {
                        return _c("el-option", {
                          key: item.type,
                          attrs: { label: item.name, value: item.type },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", size: "14" },
                    on: {
                      click: function ($event) {
                        return _vm.queryFirmwareManageList()
                      },
                    },
                  },
                  [_vm._v("查询")]
                ),
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", size: "14" },
                    on: {
                      click: function ($event) {
                        return _vm.resetSearch()
                      },
                    },
                  },
                  [_vm._v("重置")]
                ),
                _c(
                  "el-button",
                  {
                    staticClass: "add-version-btn",
                    attrs: { type: "primary", size: "14" },
                    on: { click: _vm.handleAddFirmware },
                  },
                  [_vm._v("新建固件")]
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "el-table",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading",
              },
            ],
            staticStyle: { width: "100%" },
            attrs: {
              data: _vm.tableData,
              "header-cell-style": { background: "#F5F6F7" },
              size: "medium",
            },
          },
          [
            _c("el-table-column", { attrs: { prop: "id", label: "固件Key" } }),
            _c("el-table-column", {
              attrs: { prop: "linkedProductCount", label: "已关联产品" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c(
                        "span",
                        {
                          staticClass: "linked",
                          on: {
                            click: function ($event) {
                              return _vm.handleLinkedProduct(scope.row)
                            },
                          },
                        },
                        [_vm._v(_vm._s(scope.row.linkedProductCount || 0))]
                      ),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: { prop: "name", label: "固件名称" },
            }),
            _c("el-table-column", {
              attrs: { prop: "componentTypeName", label: "固件类型" },
            }),
            _c("el-table-column", {
              attrs: { prop: "currentFirmwareVersion", label: "最新版本" },
            }),
            _c("el-table-column", {
              attrs: { prop: "updateTime", label: "创建/更新时间" },
            }),
            _c("el-table-column", {
              attrs: { fixed: "right", label: "操作", width: "200" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            type: "text",
                            disabled: _vm.rolesCode === "SALE",
                            size: "operate",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.jumpDetails(scope.row)
                            },
                          },
                        },
                        [_vm._v("详情")]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            type: "text",
                            disabled: _vm.rolesCode === "SALE",
                            size: "operate",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.handleAddVersion(scope.row)
                            },
                          },
                        },
                        [_vm._v("新建版本")]
                      ),
                      scope.row.linkedProductCount
                        ? _c(
                            "el-tooltip",
                            {
                              attrs: {
                                content: "存在关联产品或固件版本",
                                placement: "top",
                              },
                            },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    type: "text",
                                    disabled: "",
                                    size: "operate",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleDetele(scope.row)
                                    },
                                  },
                                },
                                [_vm._v("删除")]
                              ),
                            ],
                            1
                          )
                        : _c(
                            "el-button",
                            {
                              attrs: {
                                type: "text",
                                disabled: _vm.rolesCode === "SALE",
                                size: "operate",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.handleDetele(scope.row)
                                },
                              },
                            },
                            [_vm._v("删除")]
                          ),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
        _c("el-pagination", {
          attrs: {
            "current-page": _vm.currentPage,
            "page-sizes": [10, 20, 30, 40],
            "page-size": _vm.pageSize,
            layout: "total, sizes, prev, pager, next, jumper",
            total: _vm.total,
          },
          on: {
            "size-change": _vm.handleSizeChange,
            "current-change": _vm.handleCurrentChange,
          },
        }),
        _c("addFirmwareDialog", {
          ref: "addFirmware",
          attrs: {
            "query-firmware-manage-list": _vm.queryFirmwareManageList,
            "page-type": "firmwareManage",
          },
        }),
        _c("addOrEditFirmwareVersion", {
          ref: "addOrEditFirmwareVersion",
          attrs: {
            "add-or-edit-type": _vm.addOrEditType,
            "query-firmware-manage-list": _vm.queryFirmwareManageList,
            "page-type": "firmwareManage",
            "rows-data": _vm.rowsData,
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }